import { combineReducers } from 'redux';
import initialReducer from './initialReducer';

const reducer = combineReducers({
    initial: initialReducer
});

export default reducer;